import base from '@/__vue2stone/service/wasaapi/v1/__base';
import moment from 'moment';
import store from '@/store';
import i18n from '@/i18n';
import systemclass_analysis from './systemclass_analysis';
import H_file from '@/helpers/file';
import H_time from '@/helpers/time';
import H_systemClassMenu from '@/helpers/systemClassMenu';

export default {
  async index(factoryId, params, pagination = true) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'contractor_license',
      params: _params,
      pagination: pagination,
    });
    return res;
  },
  async getLicenseData(licenseId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      modelName: 'contractor_license',
      modelId: licenseId,
      params: _params,
    });
    return res;
  },
  async create(factoryId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'contractor_license',
      data: _data,
    });
    return res;
  },
  async createVersion(licenseId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'contractor_license',
      parentId: licenseId,
      modelName: 'contractor_license_version',
      data: _data,
    });
    return res;
  },
  async update(licenseId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'contractor_license',
      modelId: licenseId,
      data: _data,
    });
    return res;
  },
  async updateVersion(versionId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'contractor_license_version',
      modelId: versionId,
      data: _data,
    });
    return res;
  },
  async delete(licenseId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.delete({
      modelName: 'contractor_license',
      modelId: licenseId,
      params: _params,
    });
    return res;
  },
  async remarkUpdate(licenseVersionId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      parentName: 'contractor_license_version',
      parentId: licenseVersionId,
      modelName: 'remark',
      data: _data,
    });
    return res;
  },
  setLicenseData(data, factorySystemClassRows = []) {
    return {
      name: data.name || i18n.t('其他證照'),
      versions: [],
      updateUser: data.last_version.updated_user,
      updatedAt: H_time.getDateDashFormat(data.last_version.updated_at, 'YYYY-MM-DD HH:mm:ss'),
      image: H_file.setShowInModule(data.last_version.file_image),
      systemSubClasses: data.system_subclasses,
      multiSystemSubclasses: H_systemClassMenu.formatMultiSystemClassContentChips(
        {
          system_classes: data.system_classes,
          system_subclasses: data.system_subclasses,
          factory_system_classes: data.factory_system_classes,
          factory_system_subclasses: data.factory_system_subclasses,
        },
        { factorySystemClassRows },
      ),
      templateName: data.license_template ? data.license_template.name : '',
      status: this.getDateOverDue(data.last_version.valid_end_date),
      taker: data.last_version.taker_text || data.contractor.name || '',
      licenseNumber: data.last_version.license_number,
      approvalLetter: data.last_version.approval_letter,
      validStartDate: H_time.getDateDashFormat(data.last_version.valid_start_date),
      validEndDate: data.last_version.valid_end_date ? H_time.getDateDashFormat(data.last_version.valid_end_date) : i18n.t('無'),
      remindDate: data.last_version.remind_date ? H_time.getDateDashFormat(data.last_version.remind_date) : i18n.t('無'),
      contractor: data.contractor,
      systemClass: {},
      reminder: data.last_version.reminder,
      attaches: H_file.setShowInModule(data.last_version.file_attaches),
      precautions: data.license_template
        ? data.license_template.last_version.precautions
        : 0,
      expiredComment: data.license_template
        ? data.license_template.last_version.expired_comment
        : 0,
      creator: data.created_user,
    };
  },
  getDateOverDue(date) {
    if (!date) {
      return { color: 'red', text: '' };
    }
    let today = new Date();
    let todayDate = moment(today).format('YYYY-MM-DD');
    let targetDate = moment(date).format('YYYY-MM-DD');
    if (moment(todayDate).diff(moment(targetDate), 'days') > 0) {
      return { color: 'red', text: '資格逾期' };
    } else {
      return { color: 'red', text: '' };
    }
  },
  getCardsData(apiData) {
    apiData = systemclass_analysis.userSystemSubclassesAuthCheck(apiData)
    const licenseList = apiData;
    const _getLiceseList = licenseList.map((license) => {
      let _badges = null;
      let _remind = null;
      let _content = null;
      if (license.last_version) {
        _badges = this.getContractorLicenseStatus(
          license.last_version.valid_end_date
        );
        _remind = license.last_version.remind_date 
        ? moment(license.last_version.remind_date).format("YYYY-MM-DD")
        : null;
        _content = this.getContractorLicenseContent(license);
      }
      return {
        id: license.id,
        name: license.name,
        badges: _badges,
        remind: _remind,
        content: _content,
        system_subclasses: license.system_subclasses,
        customLinkPath: `${license.contractor.id}/contractor-license-content`
      };
    });
    return _getLiceseList
  },
  getContractorLicenseStatus(data) {
    const overdue = this.adjustOverdue(data);
    if (overdue)
      return [
        {
          text: i18n.t("資格逾期"),
          color: "red",
        },
      ];
    else return [];
  },
  getContractorLicenseContent(data) {
    const content = [];
    if (!data) return content;
    if (data.last_version.taker_text) {
      content.push({
        title: i18n.t("持有人"),
        text: data.last_version.taker_text,
      });
    } else if(data.contractor) {
      content.push({
        title: i18n.t("持有人"),
        text: data.contractor.name,
      });
    } else {
      content.push({
        title: i18n.t("持有人"),
        text: "尚待更改",
      });
    }
    if (data.last_version.license_number) {
      content.push({
        title: i18n.t("證號"),
        text: data.last_version.license_number,
      });
    } else {
      content.push({
        title: i18n.t("證號"),
        text: "",
      });
    }
    if (data.last_version.approval_letter) {
      content.push({
        title: i18n.t("核准函號"),
        text: data.last_version.approval_letter,
      });
    }
    if (data.last_version.valid_start_date) {
      let _licenseContent = {
        title: i18n.t("效期"),
        text: moment(data.last_version.valid_start_date).format("YYYY-MM-DD")+ "-",
      };
      if (!data.last_version.valid_end_date) {
        _licenseContent.text += i18n.t("無");
      } else {
        _licenseContent.text += moment(data.last_version.valid_end_date).format("YYYY-MM-DD");
      }
      content.push(_licenseContent);
    } else {
      content.push({
        title: i18n.t("效期"),
        text: "",
      });
    }
    return content;
  },
  adjustOverdue(date) {
    if (!date) return false;
    let today = new Date();
    const newDate = moment(today);
    const secondDate = moment(date);
    if (newDate.diff(secondDate, "days") > 0) {
      return true;
    } else {
      return false;
    }
  },
};
